import React from 'react'
import { WalletPage } from './wallet'

type WalletPageProps = Omit<React.ComponentProps<typeof WalletPage>, 'isCleartrip'>

const WalletMobileFlyinContent = (props: WalletPageProps) => {
    return <WalletPage {...props} isCleartrip={false} />
}

export default WalletMobileFlyinContent
